import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import './hsr-element.scss';

interface IProps {
  stat: string;
}

export const HSRStat: React.FC<IProps> = ({ stat }) => {
  return (
    <div className="hsr-stat">
      {stat === 'Anything' && (
        <>
          <span>Anything</span>
        </>
      )}
      {(stat === 'hp' || stat === 'HP') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_hp.png"
            alt="HP"
          />
          <span>HP</span>
        </>
      )}
      {stat === 'HP%' && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_hp.png"
            alt="HP"
          />
          <span>HP%</span>
        </>
      )}
      {(stat === 'def' || stat === 'DEF') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_def.png"
            alt="DEF"
          />
          <span>DEF</span>
        </>
      )}
      {stat === 'DEF%' && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_def.png"
            alt="DEF"
          />
          <span>DEF%</span>
        </>
      )}
      {(stat === 'atk' || stat === 'ATK') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_atk.png"
            alt="ATK"
          />
          <span>ATK</span>
        </>
      )}
      {stat === 'ATK%' && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_atk.png"
            alt="ATK"
          />
          <span>ATK%</span>
        </>
      )}
      {(stat === 'speed' || stat === 'Speed' || stat === 'SPD') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_speed.png"
            alt="Speed"
          />
          <span>Speed</span>
        </>
      )}
      {(stat === 'crit_rate' ||
        stat === 'CRIT Rate' ||
        stat === 'critRate') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_critrate.png"
            alt="CRIT Rate"
          />
          <span>CRIT Rate</span>
        </>
      )}
      {(stat === 'crit_dmg' || stat === 'CRIT DMG' || stat === 'critDmg') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_critdmg.png"
            alt="CRIT DMG"
          />
          <span>CRIT DMG</span>
        </>
      )}
      {(stat === 'effect_res' ||
        stat === 'effectRes' ||
        stat === 'Effect RES') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_effectres.png"
            alt="Effect RES"
          />
          <span>Effect RES</span>
        </>
      )}
      {(stat === 'effect_hit' ||
        stat === 'Effect Hit Rate' ||
        stat === 'effectHitRate') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_effecthit.png"
            alt="Effect HIT Rate"
          />
          <span>Effect HIT Rate</span>
        </>
      )}
      {(stat === 'break' || stat === 'Break Effect') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_break.png"
            alt="Break Effect"
          />
          <span>Break Effect</span>
        </>
      )}
      {(stat === 'energy_regen' ||
        stat === 'Energy Regen Rate' ||
        stat === 'energyRegen' ||
        stat === 'Energy Regeneration Rate') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_energy.png"
            alt="Energy Regen"
          />
          <span>Energy Regen Rate</span>
        </>
      )}
      {(stat === 'healing' ||
        stat === 'Outgoing Healing' ||
        stat === 'Outgoing Healing Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_healing.png"
            alt="Outgoing Healing"
          />
          <span>Outgoing Healing</span>
        </>
      )}
      {(stat === 'dmg_phys' ||
        stat === 'Physical DMG' ||
        stat === 'physicalDmg' ||
        stat === 'Physical DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_phydmg.png"
            alt="Physical DMG"
          />
          <span className="hsr-dmg phys">Physical DMG</span>
        </>
      )}
      {(stat === 'dmg_fire' ||
        stat === 'Fire DMG' ||
        stat === 'fireDmg' ||
        stat === 'Fire DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_firedmg.png"
            alt="Fire DMG"
          />
          <span className="hsr-dmg fire">Fire DMG</span>
        </>
      )}
      {(stat === 'dmg_ice' ||
        stat === 'Ice DMG' ||
        stat === 'iceDmg' ||
        stat === 'Ice DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_icedmg.png"
            alt="Ice DMG"
          />
          <span className="hsr-dmg ice">Ice DMG</span>
        </>
      )}
      {(stat === 'dmg_wind' ||
        stat === 'Wind DMG' ||
        stat === 'windDmg' ||
        stat === 'Wind DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_winddmg.png"
            alt="Wind DMG"
          />
          <span className="hsr-dmg wind">Wind DMG</span>
        </>
      )}
      {(stat === 'dmg_lightning' ||
        stat === 'Lightning DMG' ||
        stat === 'lightningDmg' ||
        stat === 'Lightning DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_lightningdmg.png"
            alt="Lightning DMG"
          />
          <span className="hsr-dmg lightning">Lightning DMG</span>
        </>
      )}
      {(stat === 'dmg_quantum' ||
        stat === 'Quantum DMG' ||
        stat === 'quantumDmg' ||
        stat === 'Quantum DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_quantumdmg.png"
            alt="Quantum DMG"
          />
          <span className="hsr-dmg quantum">Quantum DMG</span>
        </>
      )}
      {(stat === 'dmg_imaginary' ||
        stat === 'Imaginary DMG' ||
        stat === 'imaginaryDmg' ||
        stat === 'Imaginary DMG Boost') && (
        <>
          <StaticImage
            src="../../../../images/starrail/icons/stat_imaginarydmg.png"
            alt="Imaginary DMG"
          />
          <span className="hsr-dmg imaginary">Imaginary DMG</span>
        </>
      )}
    </div>
  );
};
